import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import axios from "axios"

import SatisfactionWrapper from "./SatisfactionWrapper"
import { toast } from "react-toastify"

function SurveyForm() {
  const { o } = useParams()
  const hashId = o

  const [grade, setGrade] = useState(null)
  const [comment, setComment] = useState(null)

  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      if (grade == null) {
        toast.error("Escolha um grau de satisfação", {
          theme: "colored",
          autoClose: 3000,
        })

        return
      }

      const url = process.env.REACT_APP_API_URL + "survey/" + hashId
      const body = { hashresearch: hashId, grade, comment }

      await axios
        .patch(url, body)
        .then((response) => {
          toast.success("Ocorrência avaliada com sucesso", {
            theme: "colored",
            autoClose: 3000,
          })

          setSubmitted(true)
        })
        .catch((error) => {
          toast.error(error, {
            theme: "colored",
            autoClose: 3000,
          })

          setSubmitted(false)
        })
    } catch (error) {
      console.error("Error submitting grade:", error)
    }
  }

  if (submitted) {
    return <div className="msg-form">Resposta enviada!</div>
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="satisfaction-section-wrapper">
        <p>
          Em relação ao atendimento desta ocorrência, qual seu grau de
          satisfação?
        </p>
        <SatisfactionWrapper
          selectedGrade={grade}
          setSelectedGrade={setGrade}
          setComment={setComment}
        />
      </div>
      <button type="submit" className="action-btn">
        Enviar
      </button>
    </form>
  )
}

export default SurveyForm
